<div class="minCardNoContent">
    <div class="row">
        <div class="container" style="margin-top: 17%;">
            <div class="text-center">
                <div class="">
                    <i class="material-icons biggerIcon">not_interested</i>
                </div>
            </div>
            <div class="text-center font20">
                <div>
                    <h3>{{'WARNING_MESSAGES.NO_DATA_GRAPHIC' | translate}}</h3>
                    {{ 'WARNING_MESSAGES.NO_DATA_PARAMS' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>